import { TApplicationState } from 'shared/types/redux';

export function reliableSelector(state: TApplicationState) {
  return state.newbuilding.isReliableV2;
}
